import React from 'react';
import { Link } from 'react-router-dom';
import  SimpleReactValidator from 'simple-react-validator';
import Preloader from '../../../core/Preloader';
import { viewData, processData } from '../../../core/HttpAction';
import {permissionCheck} from '../../../core/Permission';
import Nopermission from '../../../core/Nopermission';
const Url='/menu';
const backUrl='/setting'+Url;
 

class AddEditAction extends React.Component {
    constructor(props) {
        super(props); 
        this.state={
            menuname:'', 
            action_name:'', 
            preloader:this.props.match.params.id?true:false,
            title:this.props.match.params.id?'Edit':'New'
        };
        this.validator = new SimpleReactValidator();
    }


    componentDidMount(){
        if(this.props.match.params.id){
            viewData(Url+'/'+this.props.match.params.id).then((res)=>{
                if(res.data.status===200){
                    let data=res.data.data;
                    this.setState({
                        menuname:data.menuname?data.menuname:'', 
                        action_name:data.action_name?data.action_name:'', 
                        preloader:false, 
                    });
                }
            });
        }
    }
 
    setStateFromInput=(event)=> {
        var obj = {};
        obj[event.target.name] = event.target.value;
        this.setState(obj);
    }

    submitForm=()=>{
        if( this.validator.allValid() ){
            let params={
                menuname:this.state.menuname,
                action_name:this.state.action_name,
            };
            let para=this.props.match.params.id?'/'+this.props.match.params.id:'';
            processData(Url+para,params).then((res)=>{
                if(res.data.status===200){
                    this.props.history.push(backUrl);
                } else{
                    const msg =res.data.message?res.data.message:'Please enter required feilds...';                     alert(msg);
                    this.setState({error_status:true,preloader:false});
                }
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
 
  
    render() {
        let {title,preloader,menuname,action_name} = this.state;
        let role=permissionCheck('roles',title);
        if(!role)
            return <Nopermission/>;
        const nameValid= this.validator.message('Name', menuname, 'required');
        const action_nameValid= this.validator.message('action_name', action_name, 'required');
        return (
            <div id="page_content_inner" className="uk-width-medium-4-10 uk-container-center">
                <h3 className="heading_b uk-margin-bottom">{title} Menu</h3>
                <div className="md-card">
                    <div className="md-card-content large-padding">
                        <div className="uk-grid">
                            <div className="uk-width-medium-1-1"> 
                                <div className={ `md-input-wrapper ${menuname ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="name">Menu Name<span className="req">*</span></label>
                                    <input type="text" name="menuname" value={menuname} onChange={this.setStateFromInput} className={ `md-input ${nameValid ?'md-input-danger':''}`} /> 
                                    {nameValid} 
                                </div>
                            </div>
                        </div>
                        <div className="uk-grid">
                            <div className="uk-width-medium-1-1"> 
                                <div className={ `md-input-wrapper ${action_name ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="name">Action Permissions<span className="req">*</span></label>
                                    <input type="text" name="action_name" value={action_name} onChange={this.setStateFromInput} className={ `md-input ${action_nameValid ?'md-input-danger':''}`} /> 
                                    {action_nameValid} 
                                </div>
                            </div>
                        </div>
                        
                        <div className="uk-grid">
                            <div className="uk-width-1-1 btn-right-align">
                                <Link to={backUrl} className="md-btn-small md-btn md-btn-danger md-btn-wave-light waves-effect waves-button waves-light">Cancel</Link>
                                <button type="button" onClick={this.submitForm} className="md-btn-small md-btn md-btn-primary md-btn-wave-light waves-effect waves-button waves-light">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
                { preloader && <Preloader/> }
            </div>  
        );
    }
}
 

export default AddEditAction;


// WEBPACK FOOTER //
// ./src/components/Setting/Menu/addEdit.js